import HomeScene from './scenes/HomeScene';
import Sdk from './sdk';
import { Scene } from './utils/consts';

class Game {
    private firstScene: Scene = Scene.HOME;
    private phaserGame: Phaser.Game;
    private playerData: any;
    private sdk?: Sdk;

    constructor(rootId: string) {
        const root = document.getElementById(rootId);
        if (!root) {
            throw new Error('There is no root element');
        }

        this.phaserGame = new Phaser.Game({
            width: window.outerWidth,
            height: window.outerHeight,
            backgroundColor: '#FFF',
            parent: root,
            pixelArt: true,
            scale: {
                mode: Phaser.Scale.RESIZE,
                width: window.outerWidth,
                height: window.outerHeight,
            }
        });
        this.initSDK().then(() => {
            this.initScene();
        });
    }

    onSetData = () => {
        const playerData = this.phaserGame.registry.get('playerData');

        console.log('onSetData', playerData);
        if (playerData !== this.playerData) {
            this.sdk?.setPlayerData(playerData);

            this.playerData = playerData;
        }
    }

    private initScene() {
        this.phaserGame.scene.add(this.firstScene, new HomeScene(), true);
    }

    private async initSDK() {
        if (location.search.includes('debug=')) {
            return;
        }
        
        this.sdk = new Sdk();
        await new Promise((resolve) => {
            this.sdk!.init().then(() => this.sdk?.getPlayerData()).then(async (data) => {
                this.playerData = data || {};

                if (!this.playerData) {
                    this.playerData = {
                        topScore: 0,
                        onboarded: false,
                    };
                    console.info('Game progress empty');
                } else {
                    console.info('Game progress received');
                    if (!('topScore' in this.playerData)) {
                        this.playerData.topScore = 0;
                    }
                    if (!('onboarded' in this.playerData)) {
                        this.playerData.onboarded = false;
                    }
                }

                this.phaserGame.registry.set('playerData', this.playerData);

                this.phaserGame.registry.set('sdk', this.sdk);
        
                this.phaserGame.registry.events.on(Phaser.Data.Events.SET_DATA, this.onSetData);

                resolve(true);
            }).catch(() => {
                // TODO: Выводить попап с ошибкой и кнопкой попробывать еще раз
            });
        });
    }
}

export default Game;